<template>
  <div class="lock-warpper">
    <!--    <div class="container-img">-->
    <!--      <h1 class="websiteTitle" v-text="websiteTitle"></h1>-->
    <!--    </div>-->
    <!--      <div class="lock-img">-->
    <!--        <img src="../../assets/images/logo4.png" alt />-->
    <!--      </div>-->
    <div class="lock-container">
      <div class="lock-img-title">
        <img :src="userInfo.avatarText|| defaultUserIcon" alt />
      </div>
      <el-form class="login-content">
        <el-form-item prop="password">
          <el-input v-model="password" placeholder="请输入密码" type="password">
            <el-button slot="prepend" icon="el-icon-lock"></el-button>
            <el-button slot="append" @click="onAlign()">忘记密码？</el-button>
          </el-input>
        </el-form-item>
        <el-form-item prop="imgCaptcha" class="input_code">
          <el-input v-model="imgCaptcha" size="large" type="text"  placeholder="请输入图形验证码"></el-input>
        </el-form-item>
        <el-form-item prop="imgCaptcha"  class="image_code">
          <el-image :src="getImgUrl" @click="handleChangeCheckCode"></el-image>
        </el-form-item>
        <div class="loginBtn">
          <el-button @click="submitHandle()">解锁</el-button>
        </div>
      </el-form>
    </div>
    <div class="record_num" v-text="icp_number"></div>
  </div>
</template>

<script>
import util from "@/utils";
import { getDoctorInfo } from "@/api/index.js";
export default {
  name: "",
  props: {},
  data () {
    return {
      defaultUserIcon: require("../../assets/images/default-avatar-doctor.png"),
      password: "",
      imgCaptcha:'',
      userInfo: {},
      icp_number: process.env.VUE_APP_ICP_NUMBER, 
      websiteTitle:process.env.VUE_APP_WEBSITE_TITLE,
      getImgUrl:'',
      redirectPath:'',
    };
  },
  created () {
    this.getDoctorInfo();
  },
  mounted () {
    this.handleChangeCheckCode()
    console.log(this.$route);
  },
  // activated () {
  //   history.pushState(null, null, document.URL);
  //   window.addEventListener('popstate', function () {
  //     history.pushState(null, null, document.URL);
  //   });
  // },
  activited () { },
  update () { },
  beforeRouteUpdate () { },
  methods: {
    go (url) {
      this.$router.push({
        path: url,
      });
    },
    onAlign () {
      const that = this;
      this.go("/forget");
    },
    /*
     * 提示信息
     * */
    elementTips: function (type, message) {
      const $t = "";
      this.$message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    // 获取图形验证码
    //  async handleChangeCheckCode () {
    //   this.currdatetime = new Date().getTime();
    //   const res = await randomImage()
    //   // if(res.success) 
    //   this.getImgUrl = res.result
    // },
    /**
     * 提交
     */
    submitHandle (userInfo) {
      const that = this;
      if (that.password === "") {
        that.elementTips("error", "请输入密码");
        return;
      }
      const params = {
        mobile: util.getStore("user_mobile"),
        password: that.password,
        captcha : this.imgCaptcha
      };
      that.submit_status = true;
      login(params).then(that.loginHandle);
    },
    loginHandle (res) {
      const that = this;
      that.submit_status = false;
      if (res.success) {
        util.removeStore("lockState");
        that.elementTips("success", res.message);  
        let redirect = this.$route.query.redirect;
        console.log(redirect);
        //   that.go(util.getStore("lockPrePath"));
        //   util.removeStore("lockPrePath");
        setTimeout(function () {
          if(redirect){
            that.$router.replace(redirect)
          }else{
            that.go("/index/work/patients")
          }
        }, 1500);
      } else {
        console.log("error", res.message);
        if (res.message === '验证码错误~') {
          this.handleChangeCheckCode()
        }
        that.elementTips("error", res.message);
      }
    },

    /**
     * 获取医生信息
     */
    // TODO 登录解锁页面
    getDoctorInfo () {
      const that = this;
      const params = {
        // "token": "8e5efaec789e8618402bafd1ce6dd22b"
      };
      getDoctorInfo(params).then(that.readyInfo);
    },
    readyInfo (res) {
      const that = this;
      if (res.success) {
        that.userInfo = res.result;
        console.log(that.userInfo, "that.userInfo");
      } else {
        that.$message({
          showClose: true,
          message: res.message,
          type: "error",
        });
      }
    },
  },
  //进入锁屏组件前,解锁后从哪里来就到那里去
  // beforeRouteEnter (to, from, next) {
  //   console.log(to, from,next);
  //   // util.setSessionStore('redirectPath',from.fullPath) //储存是为了防止用户刷新
  //   next(component => {
  //     console.log(from.fullPath);
  //     component.redirectPath = from.fullPath
  //   })
  // },
  filter: {},
  computed: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.lock-warpper {
  background-image: url("../../assets/images/login-bg1.png");
  width: 100%;
  height: 100%;
  position: relative;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: hidden;

  .container-img {
    position: relative;
    top: 35%;
    left: 50%;
    background: rgba(255, 255, 255, 0.3);
    background-color: #f4f4f4;
    margin: -190px 0 0 -175px;
    width: 400px;
    height: 400px;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    .websiteTitle {
      width: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 30px;
      color: #606266;
    }
  }

  .lock-img {
    width: 50px;
    height: 80px;
    position: relative;
    top: 5%;
    left: 35%;
  }

  .lock-img img {
    width: 150px;
    height: 70px;
  }

  .lock-img-title {
    width: 80px;
    height: 80px;
    position: relative;
    top: 5%;
    left: 35%;
  }

  .lock-img-title img {
    width: 100%;
    height: 100%;
    // border: 1px #ccc solid;
    border-radius: 50%;

    -webkit-box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
    -moz-box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
    -o-box-shadow: 0 8px 20px rgba(0, 0, 0, 0.6);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.6);
  }

  .lock-container {
    position: relative;
    top: 55%;
    left: 50%;
    background: #ffffff;
    margin: -190px 0 0 -175px;
    width: 350px;
    overflow: hidden;
    border-radius: 15px;
    background-size: 100% 100%;
    box-shadow: 0 0 30px #ccc;

    .login-content {
      padding: 30px 30px;

      .loginBtn {
        text-align: center;

        button {
          width: 100%;
          height: 36px;
          margin-bottom: 10px;
          background: #fc701a;
          color: #ffffff;
          border-color: #fc701a;
        }
      }

      .tip {
        font-size: 14px;
        color: #ddd;
      }

      .footer {
        display: flex;
        justify-content: space-around;

        .align {
          font-size: 14px;
          // color: #606266;
          color: #23b0ef;
          cursor: pointer;
        }
      }
    }
  }
  .input_code {
    width: 60%;
    float: left;
  }

  .image_code {
    width: 35%;
    float: right;
  }
  .loginBtn {
    text-align: center;

    button {
      width: 100%;
      height: 36px;
      margin-bottom: 10px;
    }
  }
}
</style>
